import { render } from "./CreateNewTrim.vue?vue&type=template&id=338f5650&scoped=true"
import script from "./CreateNewTrim.vue?vue&type=script&lang=js"
export * from "./CreateNewTrim.vue?vue&type=script&lang=js"

import "./CreateNewTrim.vue?vue&type=style&index=0&id=338f5650&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338f5650"]])

export default __exports__